import React, { useEffect, useState } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Form,
  FormGroup,
  Label,
  Col,
} from "reactstrap";
import { Colxx, Separator } from "components/common/CustomBootstrap";
import { toast } from "react-toastify";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";

import { useToken } from "auth/useToken";
import { useUser } from "auth/useUser";
import axios from "axiosClient";

const EditPartner = (props) => {
  const { toggle, partnerId } = props;
  const user = useUser();

  const initialValues = {
    fullName: "",
    organization: "",
    usedBonuses: 0,
    usedBonusesOther: 0,
  };

  const [values, setValues] = useState({});
  const [archived, setArchived] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useToken();

  const [success, setSuccess] = useState(false);
  const [updated, setUpdated] = useState(false);

  const handleChange = (e) => {
    setUpdated(true);
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(
        `/api/partner/${partnerId}`,
        { ...values, archived },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          setErrorMessage("");
          setSuccess(true);
          toast.success(
            partnerId ? "Successfully updated" : "Successfully added"
          );
        } else {
          toast.error("Something went wrong. Is the telegram ID entered?");
        }
      })
      .catch((err) => {
        // console.log(err.response.data);
        setErrorMessage(Object.values(err.response.data.errors)[0]);
        toast.error("Something went wrong. Is the telegram ID entered? (err)");
      });
  };

  useEffect(() => {
    setLoading(true);
    if (partnerId) {
      axios
        .get(`/api/partner/${partnerId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((result) => {
          setValues(result.data);
          setArchived(result.data.archived);
          setLoading(false);
        })
        .catch((e) => {
          toast.error("something went wrong");
        });
    } else {
      setValues(initialValues);
      setLoading(false);
    }
  }, [partnerId]);

  return (
    <div>
      <Row>
        <Colxx xxs="12">
          <div className="mb-2">
            <h1>{partnerId ? "Update Details" : "Add Partner"}</h1>
          </div>
          <Separator className="mb-5" />
        </Colxx>
      </Row>
      {!loading && (
        <Row className="text-left">
          <Colxx xxs="12" className="mb-4">
            <Card className="mb-4">
              <CardBody>
                <Form>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Full Name</Label>
                        <Input
                          type="text"
                          name="orgStaff"
                          value={values.orgStaff}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Organization</Label>
                        <Input
                          type="text"
                          name="organization"
                          value={values.organization}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Login</Label>
                        <Input
                          type="text"
                          name="login"
                          value={values.login}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Password</Label>
                        <Input
                          type="text"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Used Bonuses</Label>
                        <Input
                          type="number"
                          name="usedBonusesOther"
                          value={values.usedBonusesOther}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Used Bonuses (TKT)</Label>
                        <Input
                          type="number"
                          name="usedBonuses"
                          value={values.usedBonuses}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="3">
                      <FormGroup>
                        <Label>Used Bonuses (CEQs A1-B1)</Label>
                        <Input
                          type="number"
                          name="usedBonusesCeqA1B1"
                          value={values.usedBonusesCeqA1B1}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="3">
                      <FormGroup>
                        <Label>Used Bonuses (CEQs B2-C2)</Label>
                        <Input
                          type="number"
                          name="usedBonusesCeqB2C2"
                          value={values.usedBonusesCeqB2C2}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>
                          Threshold (Number of candidates for a free seat)
                        </Label>
                        <Input
                          type="number"
                          name="threshold"
                          value={values.threshold}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Threshold (TKT)</Label>
                        <Input
                          type="number"
                          name="thresholdTkt"
                          value={values.thresholdTkt}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Threshold (CEQs A1-B1)</Label>
                        <Input
                          type="number"
                          name="thresholdCeqA1B1"
                          value={values.thresholdCeqA1B1}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Threshold (CEQs B2-C2)</Label>
                        <Input
                          type="number"
                          name="thresholdCeqB2C2"
                          value={values.thresholdCeqB2C2}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <FormGroup>
                        <Label>Other Details or Comments</Label>
                        <Input
                          type="textarea"
                          name="details"
                          value={values.details}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="12" className="ml-4">
                      <FormGroup row>
                        <h4 className="mr-2">Archived</h4>
                        <Switch
                          className="custom-switch custom-switch-primary-inverse"
                          size="xs"
                          checked={archived}
                          onChange={(value) => {
                            setUpdated(true);
                            setArchived(value);
                          }}
                        />{" "}
                      </FormGroup>
                    </Col>
                    <p> </p>
                  </Row>
                </Form>
                <div>
                  <Button
                    color="primary"
                    className="top-right-button"
                    onClick={toggle}
                  >
                    Close
                  </Button>
                  {updated && (
                    <Button
                      color={success ? "success" : "primary"}
                      className="top-right-button ml-2"
                      onClick={handleSubmit}
                      disabled={success}
                    >
                      {success ? "Done" : `${partnerId ? "Update" : "Add"}`}
                    </Button>
                  )}
                </div>
                <div>{errorMessage}</div>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      )}
    </div>
  );
};

export default EditPartner;
